<div class="retirement-subform" [formGroup]="formRegister" *ngIf="disabled == false">
  <div class="retirement-subform__header">
    <h3 class="retirement-subform__title">Aposentadoria em nome de:</h3>
    <div class="retirement-subform__field">
      <b3-checkbox
        label="Entidade estrangeira"
        formControlName="developerForeigner"
        (b3-change)="onChangeForeigner($event)">
      </b3-checkbox>
    </div>
  </div>

  <div class="fields-row fields-row--2">
    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="developerCnpjAdd"
        inputId="developerCnpj__AddOthers"
        [label]="documentFieldLabel"
        background="grey"
        [mask]="developerDocumentMask"
        [placeholder]="foreigner ? 'Limite 30 caracteres' : ''"
        [error]="!foreigner && checkHasErrorDigitCounter('developerCnpjAdd')"
        [hint]="[
          { show: !foreigner && checkHasErrorDigitCounter('developerCnpjAdd'), text: 'O CPF/CNPJ deve conter 11 ou 14 dígitos.' }
        ] | fieldHint"
        (b3-blur)="onChangesInputCpfOrCnpj()">
      </b3-input-text>
    </div>
    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="developerAmount"
        inputId="developerAmount"
        label="Quantidade"
        background="grey"
        mask="integer"
        placeholder="0"
        [disabled]="disabled">
      </b3-input-text>
    </div>
  </div>

  <div class="fields-row fields-row--1">
    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="developerCompanyNameAdd"
        inputId="developerCompanyName__AddOthers"
        label="Nome ou Razão social"
        background="grey"
        mask="text"
        placeholder="Limite 100 caracteres"
        [disabled]="disabled">
      </b3-input-text>
    </div>
  </div>

  <div class="fields-row fields-row--1">
    <div class="field-group field-group--labeled">
      <label class="field-label" for="documentDescription">Detalhes</label>
      <app-b3-textarea
        formControlName="developerDescriptionAdd"
        [maxlength]="300"
        placeholder="Limite 300 caracteres"
        label=""
        type="text"
        inputId="documentDescription">
      </app-b3-textarea>
    </div>
  </div>

  <div class="retirement-subform__actions">
    <b3-button
      class="retirement-subform__add-btn"
      type="button"
      variant="outlined"
      tone="default"
      [disabled]="validateDisabledButton()"
      (b3-click)="addDevelopers()">
      {{ nameAddItem }}
    </b3-button>
  </div>

  <div class="attention">
    <b3-icon name="info" size="lg" tone="info" class="attention__icon"></b3-icon>
    <p class="attention__text">
      Distribua os créditos entre as entidades para que a soma total seja igual ao valor a ser aposentado.
      Verifique abaixo antes de concluir.
    </p>
  </div>
</div>

<div class="entities-container" *ngIf="!disabled && itens.length > 0">
  <div class="entities-container__header">
    <div class="entities-container__title-group">
      <h3 class="entities-container__title">Entidades incluídas</h3>
      <span class="entities-container__counter-badge" aria-live="polite">{{ entitiesCounterLabel }}</span>
    </div>
    <div class="entities-container__remaining">
      <span class="entities-container__remaining-label">Quantidade restante</span>
      <b3-tag
        class="entities-container__remaining-badge"
        size="sm"
        variant="filled"
        tone="warning"
        [label]="'+ ' + remainingQuantityValues"
        aria-live="polite">
      </b3-tag>
    </div>
  </div>

  <div class="entities-container__table">
    <table class="entities-table" aria-label="Entidades incluídas">
      <thead>
        <tr>
          <th scope="col" class="entities-table__col-document">CPF/CNPJ ou TAX ID</th>
          <th scope="col" class="entities-table__col-name">Nome/Razão social</th>
          <th scope="col" class="entities-table__col-quantity">Quant.</th>
          <th scope="col" class="entities-table__col-actions">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let beneficiary of itens">
          <td class="entities-table__col-document">{{ formatDocumentNumber(beneficiary.documentNumber) }}</td>
          <td class="entities-table__col-name">{{ beneficiary.beneficiaryName }}</td>
          <td class="entities-table__col-quantity">{{ beneficiary.withdrawalAmount }}</td>
          <td class="entities-table__col-actions">
            <div class="entities-table__actions">
              <button
                type="button"
                class="entities-table__action-btn"
                aria-label="Ver detalhes da entidade"
                (click)="openModal(beneficiary, 'details')">
                <b3-icon name="visibility" size="md" tone="default"></b3-icon>
              </button>
              <button
                type="button"
                class="entities-table__action-btn"
                aria-label="Excluir entidade"
                (click)="deleteRetirement(beneficiary)">
                <b3-icon name="delete" size="md" tone="default"></b3-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="entities-container__progress">
    <div class="entities-progress" role="progressbar" [attr.aria-valuenow]="valorBar" aria-valuemin="0" aria-valuemax="100">
      <div class="entities-progress__track">
        <div class="entities-progress__fill" [style.width.%]="valorBar"></div>
      </div>
      <span class="entities-progress__label">{{ progressPercentageLabel }}</span>
    </div>
  </div>
</div>

<app-modal-details-retirement
  *ngIf="isDetailsDrawerOpen"
  [(isOpen)]="isDetailsDrawerOpen"
  [beneficiary]="selectedBeneficiary">
</app-modal-details-retirement>

<b3-toast-region class="beneficiary-toast-region">
  <b3-toast
    *ngIf="activeToast as toast"
    [open]="toast.open"
    [variant]="toast.variant"
    [label]="toast.label"
    auto-dismiss
    (b3-close)="onToastDismiss()">
    <b3-button
      slot="action"
      variant="ghost"
      tone="default"
      (b3-click)="onToastUndo()">
      Desfazer
    </b3-button>
    <b3-button
      slot="close"
      variant="ghost"
      tone="default"
      aria-label="Fechar"
      (b3-click)="onToastDismiss()">
      <b3-icon name="clear" size="sm" tone="default"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
